import React, { useState } from "react";
import "../../styles/components/OurServices_2.css";

import Reveal from "../../components/Reveal";
import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";

import arrowCircle from "../../img/hero/arrow-circle-2.png";

import chatAgentsImg from "../../img/services/service-chat-agents.webp";
import analyticsImg from "../../img/services/service-analytics.webp";
import marketingImg from "../../img/services/service-marketing.webp";
import genaiMediaImg from "../../img/services/service-genai-media.webp";

const services = [
  {
    title: "AI CHAT AGENTS",
    text: [
      "Coaches, therapists, assistants, teachers that know each user's full history, goals, and current state.",
      "Not generic chatbots — personal ones that keep users coming back.",
    ],
    image: chatAgentsImg,
    variant: "blue",
  },
  {
    title: "AI ANALYTICS",
    text: [
      "Your users ask questions in plain text — and get reports, trends, and anomalies explained.",
      "An analytical agent that understands your data structure end to end.",
    ],
    image: analyticsImg,
    variant: "white",
  },
  {
    title: "MARKETING AUTOMATION",
    text: [
      "Creatives generated from competitor analysis.",
      "Analytical pipelines that monitor markets.",
      "Creative factory automation that cuts team size and time per asset.",
    ],
    image: marketingImg,
    variant: "white",
  },
  {
    title: "GENAI & MEDIA",
    text: [
      "Personalized content, visuals, and recommendations shaped by each user's behavior.",
      "Virtual try-on, image generation, coherent long-form content.",
    ],
    image: genaiMediaImg,
    variant: "blue",
  },
];

function ServiceCard({ service, direction }) {
  return (
    <article
      className={`os-card os-card--${service.variant} ${
        direction === "left" ? "os-card--from-left" : "os-card--from-right"
      }`}
    >
      <div className="os-card__content">
        <h3 className="os-card__title">{service.title}</h3>

        <div className="os-card__text">
          {service.text.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <button className="os-card__cta" type="button">
          <span>Contact Us</span>
          <img src={arrowCircle} alt="" aria-hidden="true" />
        </button>
      </div>

      <img
        className={`os-card__image ${
          service.title === "MARKETING AUTOMATION"
            ? "os-card__image--marketing"
            : ""
        }`}
        src={service.image}
        alt=""
        aria-hidden="true"
      />
    </article>
  );
}

export default function OurServices() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="os">
      <h2 className="os__title">Our services</h2>

      <div className="os__grid">
        <Reveal
          as="div"
          variant="fade"
          threshold={0.25}
          rootMargin="0px 0px -100px 0px"
          className="os-row-reveal"
        >
          <div onClick={() => setOpenModal(true)}>
            <ServiceCard service={services[0]} direction="left" />
          </div>

          <div onClick={() => setOpenModal(true)}>
            <ServiceCard service={services[1]} direction="right" />
          </div>
        </Reveal>

        <Reveal
          as="div"
          variant="fade"
          threshold={0.25}
          rootMargin="0px 0px -100px 0px"
          className="os-row-reveal"
        >
          <div onClick={() => setOpenModal(true)}>
            <ServiceCard service={services[2]} direction="left" />
          </div>

          <div onClick={() => setOpenModal(true)}>
            <ServiceCard service={services[3]} direction="right" />
          </div>
        </Reveal>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Contact us"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
